module.exports = __webpack_public_path__ + "img/knowledge_bg.4401e8a7.png";